export default __webpack_public_path__ + "static/media/logo.b95bd8d8.png";